import * as uuid from 'uuid';

export * from './gridColDefGenerator';
export * from './real-data-service';

export const randomId = () => uuid.v4();
